import { gql } from '@apollo/client';
import { COUPON_CODE_FIELDS_FRAGMENT } from './couponCodeFieldsFragment.gql';

export const LAST_MESSAGE_FIELDS_FRAGMENT = gql`
  ${COUPON_CODE_FIELDS_FRAGMENT}
  fragment LastMessageFields on Message {
    id
    objectId: id
    source
    couponCodePtr {
      ...CouponCodeFields
    }
  }
`;
